import { preprocessImage } from '@trwl/util/preprocessImage';
import Image from 'next/image';
import { MouseEventHandler } from 'react';

interface SuggestionProps {
  title: string;
  image?: string;
  onClick?: MouseEventHandler;
}

export const Suggestion = ({ title, image, onClick }: SuggestionProps) => {
  return (
    <div
      onMouseDown={onClick}
      onClick={onClick}
      className={
        'cursor-pointer w-full my-2 rounded-[6px] overflow-hidden px-0.5 bg-white hover:contrast-75 duration-300'
      }
    >
      <div className={'flex flex-row items-center gap-3 h-[70px]'}>
        <div className={'min-w-[70px]'}>
          {image && (
            <Image
              unoptimized
              width={70}
              height={70}
              className={'self-center aspect-square'}
              src={preprocessImage(image, 140)}
              alt={title}
            />
          )}
        </div>
        <div className={'line-clamp-2 overflow-hidden text-ellipsis'}>
          {title}
        </div>
      </div>
    </div>
  );
};
